<div #popover class="vl-popover vl-popover--align-left" data-vl-popover>
    <button class="js-vl-popover__toggle vl-popover__toggle" type="button" aria-expanded="false">
      {{ title }}
      <i class="vl-vi vl-vi-u-badge vl-vi-u-badge--grey vl-vi-u-badge--small vl-vi-arrow vl-vi-u-90deg"
        aria-hidden="true"></i>
    </button>
    <div class="vl-popover__content">
      <ng-content></ng-content>
      <button class="vl-popover__close-btn vl-vi vl-vi-cross" tabindex="0">
        <span class="vl-u-visually-hidden">Close popover</span>
      </button>
    </div>
  </div>